/**
 * Date: 2020-08-13 22:48:01
 * description:
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import React from "react";
import PropTypes from "prop-types";
import YxColorPicker from "./YxColorPicker";
import { IYxInputPropTypes } from "../IpropType/basePropType";

YxColorPicker.propTypes = {
  ...IYxInputPropTypes,
  value: PropTypes.string,
  onChang: PropTypes.func,
};

YxColorPicker.defaultProps = {
  value: "#fff",
  styleParam: {
    width: "md", //宽度
    size: "default", //大小
    type: "default", //类型
  },
  onChang: () => {},
};

export default YxColorPicker;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/ColorPicker/index.js